import React from 'react'

const SilhouetteIcon = ({color = 'currentColor', width = 18, height = 18, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...rest}>
        <rect x="1" y="1" width="16" height="16" rx="3" ry="3" fill={color} />
    </svg>
)

export default SilhouetteIcon
